import { render } from "./MessagesModal.vue?vue&type=template&id=7bf4f40d&scoped=true"
import script from "./MessagesModal.vue?vue&type=script&lang=js"
export * from "./MessagesModal.vue?vue&type=script&lang=js"

import "./MessagesModal.vue?vue&type=style&index=0&id=7bf4f40d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf4f40d"]])

export default __exports__